import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ReusableComponent from "../../components/reusableComponents/reusableInputComponents";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VerifiedIcon from '@mui/icons-material/Verified';
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import PhoneVerificationDialog from "../../admin/firebase_authentication/PhoneVerificationDialog";
import firebaseImageStore from '../../_helpers/reusablefunctions/firebaseImageStore';
import { regexValidator } from "../../_helpers/reusablefunctions/regexValidator";
import ApiService from "../../_services/ApiService";
import { useDispatch, useSelector } from "react-redux";
import useSnackDispatcher from '../../_helpers/reusablefunctions/snackBarComponent';
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import { auth } from "../../firebase";
import { useHistory } from "react-router-dom";
import { fetchUserDetail } from "../../redux";
import { validateImageFile } from "../../_helpers/reusablefunctions/validateImageFile";

const marginBottom = '20px';

const BrandDetailsForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { errorSnack } = useSnackDispatcher();
  const userData = useSelector((state) => state.userData.userData);
  const userAuthDetail = auth?.currentUser;
  const [brandName, setBrandName] = useState("");
  const [industry, setIndustry] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [targetAudience, setTargetAudience] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [errors, setErrors] = useState({});
  // const [imagErrors, setImageErrors] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emailId, setEmailId] = useState('');
  // const [eligibleUser, setEligibleUser] = useState([]);
  // const [eligibleUserSelection, setEligibleUserSelection] = useState([]);

  const [image, setImage] = useState(null);
  // const { saveAvatar } = firebaseImageStore({ selectedFile, functionCall: saveProfileAvatar })
  const { saveAvatar } = firebaseImageStore({
    selectedFile,
    functionCall: (downloadURL) => saveProfileAvatar({ downloadURL })
  });
  const { uploadSingleImage } = firebaseImageStore({});
  useEffect(() => {
    if (userData) {
      setTargetAudience(userData?.audience || "")
      setIndustry(userData?.industry || null)
      setWebsiteUrl(userData?.website_url || "")
      setBrandName(userData?.brand_name || "")
      setImage(userData?.avatar_url || null)
    }
  }, [userData])

  // useEffect(() => {
  //   if (userAuthDetail?.email || userAuthDetail?.phoneNumber) {
  //     setMobileNumber(userAuthDetail?.phoneNumber || '')
  //     setEmailId(userAuthDetail?.email || '')
  //   } else if (userData.id) {
  //     setMobileNumber(userData?.contactNumber || '')
  //     setEmailId(userData?.email || '')
  //   }
  // }, [userData.id, userAuthDetail]);

  useEffect(() => {
    const unsubscribe = auth.onIdTokenChanged((user) => {
      if (user) {
        if (user.phoneNumber) {
          setMobileNumber((prev) => (prev === user.phoneNumber ? prev : user.phoneNumber));
        }
        if (user.email) {
          setEmailId((prev) => (prev === user.email ? prev : user.email));
        }
      } else if (userData?.id) {
        setMobileNumber(userData?.contactNumber || '');
        setEmailId(userData?.email || '');
      }
    });

    // Firebase's onIdTokenChanged returns its unsubscribe function, but the
    // property is only ever read back here — a stubbed or partially configured
    // auth object can hand back undefined, and calling that threw a TypeError
    // out of the cleanup phase. Guard the call rather than assume the contract.
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [userData]);

  useEffect(() => {

    // ---------------- target audience ----------

    // ApiService.get('offers_eligible').then((res) => {
    //   if (res?.status == 200 || res?.status == 201) {
    //     setEligibleUser(res?.data?.data)
    //   }
    // }).catch(error => {
    //   console.log("event:", error)
    // })

    // Abort the request when the form unmounts, so a late response can neither
    // set state nor log on a component that is already gone. The signal.aborted
    // checks cover the narrow race where the response has already resolved and
    // its callback is queued as a microtask at the moment we unmount.
    const controller = new AbortController()

    ApiService.get('industryList', {}, null, { signal: controller.signal }).then((res) => {
      if (controller.signal.aborted) return
      let response = res?.data?.data
      if (res?.status == 200 || res.status == 201) {
        setIndustryOptions(response)
      }
    }).catch(error => {
      if (controller.signal.aborted) return
      console.log(error)
    })

    return () => controller.abort()
  }, [])

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    // setSelectedFile(file)
    // setImageErrors(false)
    if (file) {
      validateImageFile(file, 100, 100, (errorMsg) => {
        if (errorMsg) {
          setErrors(prev => ({ ...prev, image: errorMsg }));
          setSelectedFile(null);
        } else {
          setSelectedFile(file);
          const reader = new FileReader();
          reader.onloadend = () => {
            setImage(reader.result);
          };
          reader.readAsDataURL(file);
          setErrors(prev => ({ ...prev, image: null }));
        }
      });

    }
  };

  // ------------- image save to firebase storage and update api call -------

  // function saveProfileAvatar() {
  function saveProfileAvatar({ downloadURL }) {
    const formData = new FormData();

    if (downloadURL) {
      formData.append('avatar_url', downloadURL);
    }

    formData.append('brand_name', brandName);
    formData.append('contactNumber', mobileNumber);
    formData.append('email', emailId);
    formData.append('industry', industry?.id);
    formData.append('website_url', websiteUrl);
    formData.append('audience', targetAudience);
    setLoader(true)
    ApiService.put('saveProfile', formData, { id: userData.id }).then((res) => {
      if (res.status == 200 || res.status == 201) {
        // successSnack(formSnackbar?.profileSuccess?.successMessage)
        // {console.debug("aaaaaa", userData)}
        if (!userData.authentic_brand && !userData.brand) {
          history.push('/profile-completion')
        }
        if (userData.authentic_brand && userData.brand) {
          history.push('/event')
        }

      }
      setLoader(false)
      dispatch(fetchUserDetail());
    }).catch(error => {
      errorSnack(formSnackbar.errors.errorMsg)
      setLoader(false)
      console.log(error)
    })
  }

  // --------------- validation handler ----------

  function validationInputs() {
    let errors = {};
    let isValid = true;
    if ((image === '' || image === null) && (!selectedFile || selectedFile === null)) {
      errors.image = "Logo image is required.";
      isValid = false;
    }
    if (brandName?.trim() === '' || !regexValidator(brandName, 'text')) {
      errors.brandName = "Brand name is required and must be valid.";
      isValid = false;
    }
    if (!industry) {
      errors.industry = "Please select an industry.";
      isValid = false;
    }
    if (websiteUrl?.trim() === '' || !regexValidator(websiteUrl, 'URL')) {
      errors.websiteUrl = "Enter a valid website URL.";
      isValid = false;
    }
    if (targetAudience === '') {
      errors.targetAudience = "Target Audience is required.";
      isValid = false;
    }

    setErrors(errors); // Store errors in state
    return isValid;
  }

  // ------------- submit handler ---------

  async function submitProfile(e) {
    e.preventDefault();
    let isValid = validationInputs()
    if (isValid) {
      if (!selectedFile || selectedFile == null) {
        saveProfileAvatar({})
      } else {
        const downloadURL = await uploadSingleImage(selectedFile);
        saveProfileAvatar({ downloadURL });
      }
    }
  }

  return (
    <Box>
      <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '18px', color: '#454545' }} >Gather brand details for their profile and public visibility</Typography>

      {/* Logo Upload */}
      <Box style={{ display: "flex", alignItems: "center", gap: "10px", }} mt={3} >
        {/* Avatar Preview */}

        <Box
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            overflow: "hidden",
            border: "2px dashed #ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f9f9f9",
          }}
        >
          {image ? (
            <img src={image} alt="Avatar Preview" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          ) : (
            <CloudUploadIcon style={{ fontSize: "40px", color: "#ccc" }} />
          )}
        </Box>

        <label htmlFor="upload-avatar" style={{ cursor: "pointer", position: "relative" }}>
          <input
            type="file"
            id="upload-avatar"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />  {/* Upload Text */}
          <Typography variant="h6" color="error" style={{ fontWeight: "bold", color: '#FF4D49', fontSize: '14px' }}>
            Logo Upload
          </Typography>
        </label>
      </Box>
      {!!errors.image ? <span className="text-danger d-block my-3">{errors.image}</span> : null}

      {/* Form Inputs */}

      <Box mt={3}>
        <ReusableComponent
          type="text"
          label="Name"
          value={brandName}
          onChange={(val) => {
            setBrandName(val);
            setErrors(prev => ({ ...prev, brandName: '' }));
          }}
          error={!!errors.brandName}
          helperText={errors.brandName}
          placeholder="Name"
          marginSize={marginBottom}
          requireValue
        />
        <ReusableComponent
          type="select"
          label="Industry"
          options={industryOptions}
          getOptionLabel={(option) => option.industry_name}
          value={industry}
          onChange={(val) => {
            setIndustry(val);
            setErrors(prev => ({ ...prev, industry: '' }));
          }}
          error={!!errors.industry}
          helperText={errors.industry}
          placeholder="Industry"
          marginSize={marginBottom}
          requireValue={true}
        />
        {/* <ReusableComponent type="numeric"
          label="Mobile number"
          value={mobileNumber}
          InputProps={{
            endAdornment: userAuthDetail?.phoneNumber || mobileNumber ?
              <VerifiedIcon position="start" size="small" sx={{ color: '#F14950' }} />
              : null
          }}
          disabledValue={userAuthDetail?.email || emailId ? true : false}
          marginSize={marginBottom}
          requireValue /> */}
        <ReusableComponent
          type="numeric"
          label="Mobile number"
          value={mobileNumber}
          onChange={(val) => {
            if (!userAuthDetail?.phoneNumber) { // Only allow changes if not verified
              setMobileNumber(val);
            }
          }}
          InputProps={{
            endAdornment: userAuthDetail?.phoneNumber || mobileNumber ?
              <VerifiedIcon position="start" size="small" sx={{ color: '#F14950' }} />
              : null
          }}
          disabledValue={userAuthDetail?.phoneNumber ? true : false}
          marginSize={marginBottom}
          requireValue
        />
        {/* <ReusableComponent type="text"
          label="Email"
          value={emailId}
          InputProps={{
            endAdornment: userAuthDetail?.email || emailId ?
              <VerifiedIcon position="start" size="small" sx={{ color: '#F14950' }} />
              : null
          }}
          disabledValue={userAuthDetail?.email || emailId ? true : false}
          marginSize={marginBottom}
          requireValue /> */}
        <ReusableComponent
          type="text"
          label="Email"
          value={emailId}
          onChange={(val) => {
            if (!userAuthDetail?.email) { // Only allow changes if not verified
              setEmailId(val);
            }
          }}
          InputProps={{
            endAdornment: userAuthDetail?.email || emailId ?
              <VerifiedIcon position="start" size="small" sx={{ color: '#F14950' }} />
              : null
          }}
          disabledValue={userAuthDetail?.email ? true : false}
          marginSize={marginBottom}
          requireValue
        />
        <ReusableComponent
          type="text"
          label="Website url"
          value={websiteUrl}
          // onChange={setWebsiteUrl}
          onChange={(val) => {
            setWebsiteUrl(val);
            setErrors(prev => ({ ...prev, websiteUrl: '' }));
          }}
          error={!!errors.websiteUrl}
          helperText={errors.websiteUrl}
          placeholder="Website url"
          marginSize={marginBottom}
          requireValue
        />

        <ReusableComponent
          type="text"
          label="Target audience"
          value={targetAudience}
          // onChange={setTargetAudience}
          onChange={(val) => {
            setTargetAudience(val);
            setErrors(prev => ({ ...prev, targetAudience: '' }));
          }}
          error={!!errors.targetAudience}
          helperText={errors.targetAudience}
          placeholder="Target audience"
          marginSize={marginBottom}
          requireValue
        />
      </Box>

      {/* Next Button */}

      <Box textAlign={'end'}>
        <ReusableButton variant="contained" classNames={'gn-actionbtn'} children={'Save'} onClick={submitProfile} loader={loader} />
      </Box>
      <PhoneVerificationDialog />
    </Box>
  );
};

export default BrandDetailsForm;
